import {MapLayer} from "@esWebAPI/es/map/layer/MapLayer";
import {AzureLineLayer} from "@esWebAPI/es/map/layer/azure/AzureLineLayer";
import {ExpressionFilterSpecification} from "@maplibre/maplibre-gl-style-spec";
import {ILayerView, LayerInfo, LayerUpdateMetadata} from "@esWebAPI/es/model/Layer";
import {DatasourceManager} from "@esWebAPI/es/map/module/DatasourceManager";
import {IEventChannel} from "@esWebAPI/es/model/Models";
import {ThematicStylerFactory} from "@esWebAPI/es/map/styler/ThematicStylerFactory";
import {source, Map} from "azure-maps-control";

export class LineLayer extends MapLayer {

    private _lineLayer: AzureLineLayer

    private datasource: source.Source|undefined;


    constructor(map: Map, layerView: ILayerView, layerInfo: LayerInfo,
                datasourceManager: DatasourceManager,
                stylerFactory: ThematicStylerFactory,
                eventChannel: IEventChannel) {
        super(map, layerView, layerInfo, datasourceManager, eventChannel);

        this._lineLayer = new AzureLineLayer(map, layerView, datasourceManager, stylerFactory.getColorStyler(layerView));

        this.createLayer().then(() => this.onReady.resolve());
    }

    private async createLayer() {
        this.datasource = await this.datasourceManager.create(this.layerView, this.layerInfo, false);
        await this._lineLayer.create(this.datasource);
    }

    protected getSymbolThematicFilter(): ExpressionFilterSpecification | undefined {
        return undefined;
    }

    protected getColorThematicFilter(): ExpressionFilterSpecification | undefined {
        return undefined;
    }

    protected hideFeature(): void {}

    protected showFeatures(): void {}

    public update(_layerUpdateMetadata: LayerUpdateMetadata): Promise<void> {
        return this._lineLayer.update(this.layerView);
    }

    public destroy(): void {
        super.destroy();
        this._lineLayer.remove();
        if (this.datasource) {
            this.datasourceManager.remove(this.datasource.getId());
        }
    }

    public show() {
        this._lineLayer.show();
    }

    public hide() {
        this._lineLayer.hide();
    }

    public getLayerIds(): string[] {
        return [this._lineLayer.getLayerId()];
    }

    public getActiveAzureLayerId(): string | undefined {
        return this._lineLayer.getLayerId();
    }
}
